<template>
    <div class="p-fluid formgroup-inline grid">
        <div class="field col-1 font-medium">No</div>
        <div class="field col-4 font-medium">Description</div>
        <div class="field col-2 font-medium">Weight</div>
        <div class="field col-2 font-medium">Score</div>
        <div class="field col-1 font-medium">Total Score</div>
    </div>
    <div v-for="(item, index) in assessements" class="p-fluid formgroup-inline grid">
        <div class="field col-1">
            {{ item.no }}
        </div>
        <div class="field col-4">
            {{ item.description }}
        </div>
        <div class="field col-2 mt-2">
            <span class="font-medium">{{ item.weight }}</span>
        </div>
        <div class="field col-2">
            <InputText id="score" type="number" :min="0" :max="100" placeholder="0" v-model="item.score" @input="calculateScore(index, item.score)"/>
        </div>
        <div class="field col-1">
            <span class="font-medium">{{ item.total_score }}</span>
        </div>
    </div>
    <div class="p-fluid formgroup-inline grid">
        <div class="field col-7 font-medium">Category : {{ resultCategory }}</div>
        <div class="field col-2 font-medium"></div>
        <div class="field col-1 font-medium">Total Score: {{ totalScore }}</div>
    </div>
</template>
<script>
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import InputText from "primevue/inputtext";
import axios from "axios";

export default {
    components: {
        Button, Dropdown, Calendar, InputText, Checkbox,
    },
    props: ['models'],
    data() {
        return {
            assessements: [
                {no: 1, description: "Kedisiplinan", field_name: "first_score", weight: 15, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.first_score, total_score: 0},
                {no: 2, description: "Dedikasi dan Loyalitas",field_name: "second_score", weight: 10, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.second_score, total_score: 0},
                {no: 3, description: "Komunikasi dan Kerjasama",field_name: "third_score", weight: 10, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.third_score, total_score: 0},
                {no: 4, description: "Kemandirian",field_name: "fourth_score", weight: 5, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.fourth_score, total_score: 0},
                {no: 5, description: "Kuantitas Pekerjaan",field_name: "fifth_score", weight: 20, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.fifth_score, total_score: 0},
                {no: 6, description: "Kualitas Pekerjaan",field_name: "sixth_score", weight: 20, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.sixth_score, total_score: 0},
                {no: 7, description: "Inisiatif / Prakarsa",field_name: "seventh_score", weight: 10, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.seventh_score, total_score: 0},
                {no: 8, description: "Waktu Penyelesaian Pekerjaan",field_name: "eigth_score", weight: 10, score: this.$page.props.assessement === undefined ? 0 : this.$page.props.assessement.eigth_score, total_score: 0},
            ],
            form: this.$page.props.assessement ?? {is_passed: false, is_exception: false},
            submitted: false,
            employees: {},
            options: ['Baik Sekali', 'Baik', 'Cukup', 'Kurang'],
            option_recommedations: ['Disarankan', 'Dapat Disarankan', 'Masih Dapat Disarankan', 'Tidak Disarankan'],
        }
    },
    computed: {
        resultCategory(){
            let totalSummary = this.assessements.reduce((total, item) => parseInt(item.total_score) + total, 0);
            let category = "D";
            if(totalSummary >= 8500 && totalSummary <= 10000){
                category = "A";
            }
            else if(totalSummary >= 7000 && totalSummary < 8500 ){
                category = "B";
            }
            else if(totalSummary >= 6000 && totalSummary < 7000){
                category = "C";
            }
            else{
                category = "D";
            }
            this.form.result_category = category;
            return category;
        },
        totalScore() {
            let totalSummary = this.assessements.reduce((total, item) => parseInt(item.total_score) + total, 0);
            this.form.total_score = totalSummary;
            return totalSummary;
        },
    },
    mounted() {
        this.loadData();
        this.calculateAllScore();
    },
    methods: {
        calculateScore(index, score){
            this.assessements[index].total_score = this.assessements[index].weight * score
        },
        calculateAllScore(){
            let total = 0;
            this.assessements.forEach(element => {
                element.total_score = element.weight * element.score;
                total += element.total_score;
            });
            this.form.total_score = total;
        },
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/employees`)
            .then((data)=>{
                this.employees = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        }
    }
}
</script>
